import { atom, selectorFamily } from 'recoil';

type SortingState = {
  sortKey: string | null;
  sortDirection: 'asc' | 'desc' | null;
};

export const genericListSorting = atom<Record<string, SortingState>>({
  key: 'genericListSorting',
  default: {},
});

export const genericListSortingState = selectorFamily<SortingState, string>({
  key: 'genericListSortingState',
  get:
    (listKey) =>
    ({ get }) =>
      get(genericListSorting)[listKey] || { sortKey: null, sortDirection: null },
  set:
    (listKey) =>
    ({ get, set }, newValue) => {
      const currentSorting = get(genericListSorting);
      set(genericListSorting, { ...currentSorting, [listKey]: newValue as SortingState });
    },
});
